/*eslint-disable*/
import React, { Component } from "react"
import { bindActionCreators } from "redux"
import moment from "moment"
import { connect } from "react-redux"
import { message } from "antd"
import { formatMoney } from "accounting"
import CloudFlyerAPI from "../../api/CloudFlyerAPI"

import { fetch_clouds } from "../../actions/cloud-accounts-actions"

import EditableBudget from "./editable-budget"
import FinanceTrend from "./finance-trend"
import FinanceTable from "./finance-table"
import FinanceHeader from "./finance-header"
import FinanceSettings from "./finance-settings"
import AddProduct from "./AddProduct"
import Alerts from "./Alerts"

import PricingModal from "../PricingModal"

import "./styles.scss"

class Finance extends Component {
  constructor(props) {
    super(props)

    const { user } = this.props

    this.hasAccess =
        user && user.packages && user.packages.map(p => p.title).includes("Finance")

    this.categories = [
      "Compute",
      "Storage",
      "Database",
      "Transfer",
      "Automation",
      "Infrastructure",
      "Monitoring",
      "Others"
    ]

    this.state = {
      chart_width: window.innerWidth - 130,
      selected_service: null,
      selected_service_name: null,
      chart_data: [],
      settings: {},
      settings_visible: false,
      has_write_perm: true,

      clouds: [],
      date_selection_ranges: [],
      selected_date_range: new Date().getFullYear().toString(),
      selected_year: new Date().getFullYear().toString(),
      months: [],

      alert_emails: [],
      logs_emails: [],
      logs_frequency: "Monthly",
      categories: this.categories,

      tree: [],
      data: {
        //2018:{charts:[], hierarchicals:{}}
      }
    }
  }

  async componentDidMount() {
    this.refresh_tree()
    this.build_date_ranges()
    window.addEventListener("resize", () =>
      this.setState({ chart_width: window.innerWidth - 130 })
    )
    await this.load_local_settings()
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      alert_emails: this.state.alert_emails.length
        ? this.state.alert_emails
        : [nextProps.user.email],
      logs_emails: this.state.logs_emails.length
        ? this.state.logs_emails
        : [nextProps.user.email]
    })
  }

  build_date_ranges = () => {
    let today = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    let this_year = today.getFullYear()
    let this_month = today.getMonth()
    let generate_dates = (count, year, month) =>
      [...Array(count).keys()].map(
        i =>
          new Date(year || this_year, (month || this_month) - count + i + 1, 1)
      )

    const date_selection_ranges = [
      {
        label: this_year + 1,
        months: generate_dates(12, this_year + 1, 11),
        value: (this_year + 1).toString(),
        year: this_year + 1
      },
      {
        label: "This Year",
        months: generate_dates(12, this_year, 11),
        value: this_year.toString(),
        year: this_year
      },
      {
        label: this_year - 1,
        months: generate_dates(12, this_year - 1, 11),
        value: (this_year - 1).toString(),
        year: this_year - 1
      },
      {
        label: "Last 6 months",
        months: generate_dates(6),
        value: "Last 6 months",
        year: this_year
      },
      {
        label: "Last 3 months",
        months: generate_dates(3),
        value: "Last 3 months",
        year: this_year
      },
      {
        label: "This month",
        months: generate_dates(1),
        value: "This month",
        year: this_year
      }
    ]
    this.setState(({ months }) => ({
      date_selection_ranges,
      months: months.length
        ? months
        : date_selection_ranges.find(r => r.value === this_year.toString())
            .months
    }))
  }

  load_local_settings = async () => {
    let settings = await CloudFlyerAPI.finance.settings()
    this.setState({ ...this.state, ...((settings||{}).data || {}) })
  }

  format_price = price => {
    const { show_decimal, show_dollar_sign } = this.state
    const options = {}
    if (!show_decimal) options.precision = 0
    options.format = show_dollar_sign ? "%s%v" : "%v"
    return formatMoney(price, options)
  }

  on_settings_change = ({ target }) =>
    this.setState({ [target.name]: target.checked })

  toggle_set_alert = () =>
    this.setState({ set_alert_visible: !this.state.set_alert_visible })

  open_alerts = () => this.alerts_modal.open()

  show = modal => this.setState({ [`${modal}_visible`]: true })

  hide = modal => this.setState({ [`${modal}_visible`]: false })

  on_save_settings = cancel => {
    const {
      alert_emails,
      logs_emails,
      logs_frequency,
      show_dollar_sign,
      show_decimal,
      show_border,
      settings_visible
    } = this.state
    if (!settings_visible || cancel)
      return this.setState({ settings_visible: !settings_visible || false })

    CloudFlyerAPI.finance
      .put_settings({
        alert_emails,
        logs_emails,
        logs_frequency,
        show_dollar_sign,
        show_decimal,
        show_border
      })
      .then(() =>
        this.setState(
          ({ settings_visible }) => ({ settings_visible: !settings_visible }),
          () => message.success("Settings saved successfully.")
        )
      )
      .catch(err =>
        message.error(
          err.message || "Failed to save settings, please try again."
        )
      )
  }

  on_service_change = (key, value) =>
    this.setState({ [key]: value }, this.build_chart)

  on_service_compare_toggle = () => {
    if (this.state.selected_service_cmp) {
      const chart_data = this.state.chart_data.map(d => ({
        month: d.month,
        actual: d.actual,
        budget: d.budget
      }))
      this.setState(
        { selected_service_cmp: null, chart_data },
        this.build_chart
      )
    } else
      this.setState(
        {
          selected_service_cmp:
            ((this.state.clouds[0] || {}).project_name || "Add. Services") +
            " total"
        },
        this.build_chart
      )
  }

  on_selected_date_range_change = value => {
    value = value || new Date().getFullYear()
    let range =
      this.state.date_selection_ranges.find(r => r.value === value) || {}
    value &&
      this.setState(
        () => ({
          selected_date_range: value,
          selected_year: range.year,
          months: range.months || []
        }),
        () => {
          if (!this.state.data[range.year])
            this.refresh_yearlies(new Date(value, 0, 1))
          else this.build_chart()
        }
      )
  }

  refresh_tree = () => {
    const { tree_loading } = this.state
    if (tree_loading) return
    this.setState({ tree_loading: true })
    CloudFlyerAPI.finance
      .tree()
      .then(({ data: tree }) => {
        let clouds = tree
          .filter(c => c.cloud && true)
          .map(c => ({ id: c.cloud, project_name: c.title }))
        let first_cloud = clouds.length ? clouds[0] : {}

        this.setState({ tree, clouds, tree_loading: false }, () =>
          this.setState({
            selected_service:
              !this.state.selected_service &&
              clouds.length &&
              first_cloud.project_name
                ? first_cloud.project_name.toTitleCase() + " total"
                : this.state.selected_service
          })
        )
      })
      .then(this.refresh_yearlies)
      .catch(() => this.setState({ tree_loading: false }))
  }

  refresh_yearlies = async date => {
    for (let job of this.state.clouds.map(c => () => this.refresh_yearly(c.id)))
      await job()
    await this.refresh_yearly("", date)
  }

  refresh_yearly = (id, date) => {
    date = date || new Date(this.state.selected_date_range, 0, 1)
    this.setState({ loading: true })
    CloudFlyerAPI.finance
      .hierarchical(id, date)
      .then(({ data: { chart, hierarchical } = {} }) => {
        let year = date.getFullYear()
        let yearly_data = this.state.data[year] || {
          charts: {},
          hierarchicals: {}
        }
        if (chart) yearly_data.charts = { ...yearly_data.charts, ...chart }
        if (hierarchical)
          yearly_data.hierarchicals[id || "Add. Services"] = hierarchical
        let data = { ...this.state.data, ...{ [year]: yearly_data } }

        this.setState(
          {
            data
          },
          () => {
            this.build_chart()
            this.setState({ loading: false })
          }
        )
      })
      .catch(() => this.setState({ loading: false }))
  }

  build_chart = () => {
    let {
      data,
      selected_service = "",
      selected_service_cmp,
      selected_date_range,
      date_selection_ranges
    } = this.state
    let selected_year = (
      date_selection_ranges.find(r => r.value === selected_date_range) || {
        year: new Date().getFullYear()
      }
    ).year
    let chart_data =
      ((data[selected_year] || {}).charts || {})[selected_service] || []
    if (selected_service_cmp) {
      let cmp = data[selected_year].charts[selected_service_cmp] || []
      chart_data = chart_data.map((p, i) => {
        let cmp_p = cmp.find(v => v.month === p.month) || {}
        return {
          ...p,
          ["actual_cmp"]: cmp_p.actual,
          ["budget_cmp"]: cmp_p.budget
        }
      })
    }
    this.setState({ chart_data })
  }

  build_columns = () => {
    let {
      selected_year,
      months = [],
      show_border,
      has_write_perm
    } = this.state
    const today = new Date(new Date().getFullYear(), new Date().getMonth(), 1)

    let lastIndex = 0
    const new_index = () => {
      lastIndex++
      return lastIndex
    }

    const past_columns = () => {
      let past_months = months.filter(m => m <= today)
      if (!past_months.length) return null

      let childrens = past_months.map(month => {
        let month_name = moment(month).format("MMM")
        return {
          title: month_name,
          dataIndex: `${month_name}.actual`,
          key: `${new_index()}.actual`,
          className: show_border
            ? "actual-col striped-col"
            : "actual-col striped-col borderless",
          align: "right",
          width: 100,
          render: (value, record = {}) => {
            let month_record = record[month_name] || {}
            if (!record.cloud)
              return (
                <EditableBudget
                  value={value || 0}
                  month={month}
                  editable={has_write_perm}
                  record={record}
                  show_yellow_alert={(month_record || {}).budget_warning}
                  toggle_set_alert={this.toggle_set_alert}
                  on_save={(value, record, month) =>
                    this.on_budget_save(value, undefined, record, month)
                  }
                  format_price={this.format_price}
                />
              )

            return (
              <div
                className={
                  month_record.budget && value > month_record.budget
                    ? "alert"
                    : ""
                }
              >
                {this.format_price(value)}
              </div>
            )
          }
        }
      })
      return {
        title: "Actual",
        className: "month-col hr-line",
        children: childrens
      }
    }

    const future_columns = () => {
      let future_months = months.filter(m => m >= today)
      if (!future_months.length) return null
      let childrens = future_months.map(month => {
        let month_name = moment(month).format("MMM")
        return {
          title: month_name,
          dataIndex: `${month_name}.budget`,
          key: `${new_index()}.budget`,
          className: show_border
            ? "budget-col striped-col"
            : "budget-col striped-col borderless",
          align: "right",
          width: 100,
          render: (value, record = {}) => (
            <EditableBudget
              value={value || 0}
              month={month}
              editable={has_write_perm}
              record={record}
              show_yellow_alert={(record[month_name] || {}).budget_warning}
              toggle_set_alert={this.toggle_set_alert}
              on_save={(value, record, month) =>
                this.on_budget_save(undefined, value, record, month)
              }
              format_price={this.format_price}
            />
          )
        }
      })
      return {
        title: "Budget",
        className: "month-col hr-line",
        children: childrens
      }
    }

    let yearly_actual =
      parseFloat(selected_year) <= today.getFullYear()
        ? [
            {
              title: "Actual",
              dataIndex: "actual",
              key: `${new_index()}.Year End`,
              className: show_border
                ? "actual-col striped-col"
                : "actual-col striped-col borderless",
              align: "right",
              width: 150,
              render: (value, record = {}) => (
                <div
                  className={
                    record.budget && value > record.budget ? "alert" : ""
                  }
                >
                  {this.format_price(value)}
                </div>
              )
            }
          ]
        : []

    let yearly_budget =
      parseFloat(selected_year) >= today.getFullYear()
        ? [
            {
              title: "Budget",
              dataIndex: "budget",
              key: `${new_index()}.Year End`,
              className: show_border
                ? "budget-col striped-col"
                : "budget-col striped-col borderless",
              align: "right",
              width: 150,
              render: (value, record = {}) => (
                <EditableBudget
                  value={value}
                  month={null}
                  show_yellow_alert={record.budget_warning}
                  editable={has_write_perm}
                  record={record}
                  on_save={(value, record, month) =>
                    this.on_budget_save(undefined, value, record, month)
                  }
                  format_price={this.format_price}
                />
              )
            }
          ]
        : []

    const past_cols = past_columns()
    const future_cols = future_columns()

    const columns = past_cols ? [past_cols] : []
    if (future_cols) columns.push(future_cols)

    return [
      {
        dataIndex: `${moment(today).format("MMM")}.label`,
        key: `${new_index()}.label`,
        className: "service-col",
        fixed: "left",
        width: 200
      },
      ...columns,
      {
        title: `${
          parseFloat(selected_year) >= today.getFullYear()
            ? "Year To Date"
            : "All Of " + selected_year
        }`,
        className: "month-col",
        align: "center",
        children: [...yearly_actual, ...yearly_budget]
      }
    ]
  }

  on_budget_save = (actual, budget, record = {}, month) => {
    let end = new Date(
      month
        ? Date.UTC(month.getFullYear(), month.getMonth() + 1, 0)
        : Date.UTC(parseFloat(this.state.selected_year) + 1, 0, 0)
    )
    CloudFlyerAPI.finance
      .put(
        record.cloud,
        record.label,
        actual,
        budget,
        !month,
        month ? month : new Date(this.state.selected_year, 0, 1),
        end
      )
      .then(() => {
        message.success("Budget updated successfully")
        this.refresh_yearly(
          record.cloud,
          new Date(this.state.selected_year, 0, 1)
        )
      })
      .catch(() => message.error("Error updating budget, please try again."))
  }

  on_emails_changes = (type, emails) => this.setState({ [type]: emails })

  on_frequency_change = logs_frequency => this.setState({ logs_frequency })

  on_change = e => {
    const { name, value } = e.target || e
    this.setState({ [name]: value })
  }

  on_save_product = () => {
    const {
      product_category: category = "Others",
      product_name: name
    } = this.state
    if (!name) return message.warn("Please enter a valid product name.")
    CloudFlyerAPI.finance
      .save_product({ category, name })
      .then(() => {
        this.hide("add_product")
        message.success("Product saved successfully.")
      })
      .then(this.refresh_tree)
      .catch(err =>
        message.error(
          err.message || "Failed to save product, please try again."
        )
      )
  }

  on_search = value =>
    this.setState({
      categories:
        value && value !== "" ? [...this.categories, value] : this.categories
    })

  on_focus = () => this.setState({ categories: this.categories })

  render() {
    const { history } = this.props;
    const {
      data = {},
      tree,
      clouds,
      selected_service,
      selected_cloud,
      set_alert_visible,
      alerts_visible,
      date_selection_ranges,
      selected_date_range,
      selected_year,
      settings_visible,
      has_write_perm,
      alert_emails,
      logs_emails,
      logs_frequency,
      show_dollar_sign,
      show_decimal,
      show_border,
      loading,
      add_product_visible,
      product_category,
      product_name,
      categories,
      tree_loading
    } = this.state

    const hierarchicals =
      Object.values(
        (
          data[selected_year || new Date().getFullYear()] || {
            hierarchicals: {}
          }
        ).hierarchicals
      ) || []

    return (
      <div className="analytics-finance">
        {!this.hasAccess && (
          <PricingModal
            productName="Finance"
            product="finance"
            monthlyPricing={20}
            annuallyPricing={199}
            onClose={period => console.log("confirmed : " + period)}
          />
        )}
        {
          <FinanceHeader
            data_source={tree}
            clouds={clouds}
            has_write_perm={has_write_perm}
            products_tree={tree}
            date_selection_ranges={date_selection_ranges}
            selected_date_range={selected_date_range}
            on_selected_date_range_change={this.on_selected_date_range_change}
            on_service_change={this.on_service_change}
            on_service_compare_add={this.on_service_compare_add}
            on_service_compare_remove={this.on_service_compare_remove}
            on_cloud_change={this.on_cloud_change}
            toggle_settings={this.on_save_settings}
            open_alerts={this.open_alerts}
            build_columns={this.build_columns}
            history={history}
          />
        }

        <FinanceTrend
          {...this.state}
          products_tree={tree}
          date_selection_ranges={date_selection_ranges}
          selected_date_range={selected_date_range}
          loading={tree_loading || loading}
          clouds={clouds}
          on_cloud_change={this.on_cloud_change}
          on_selected_date_range_change={this.on_selected_date_range_change}
          on_service_change={this.on_service_change}
          on_service_compare_toggle={this.on_service_compare_toggle.bind(this)}
        />

        {
          <FinanceTable
            data_source={hierarchicals}
            date_selection_ranges={date_selection_ranges}
            selected_year={selected_year}
            selected_date_range={selected_date_range}
            loading={!hierarchicals.length && (tree_loading || loading)}
            has_write_perm={has_write_perm}
            on_selected_year_change={this.on_selected_year_change}
            on_selected_date_range_change={this.on_selected_date_range_change}
            toggle_settings={this.toggle_settings}
            on_toggle_set_alert={this.toggle_set_alert}
            on_add_product={() => this.show("add_product")}
            build_columns={this.build_columns}
          />
        }

        <Alerts
          ref={f => (this.alerts_modal = f)}
          set_alert_visible={set_alert_visible}
          selected_cloud={selected_cloud}
          selected_service={selected_service}
          tree={tree}
          on_service_change={this.on_service_change}
          toggle_set_alert={this.toggle_set_alert}
        />

        <FinanceSettings
          visible={settings_visible}
          show_dollar_sign={show_dollar_sign}
          show_decimal={show_decimal}
          show_border={show_border}
          alert_emails={alert_emails}
          logs_emails={logs_emails}
          logs_frequency={logs_frequency}
          on_emails_changes={this.on_emails_changes}
          on_frequency_change={this.on_frequency_change}
          on_settings_change={this.on_settings_change}
          on_save={this.on_save_settings}
        />

        <AddProduct
          visible={add_product_visible}
          category={product_category}
          name={product_name}
          categories={categories}
          on_search={this.on_search}
          on_focus={this.on_focus}
          on_change={this.on_change}
          on_hide={this.hide}
          on_save={this.on_save_product}
        />
      </div>
    )
  }
}

export default connect(
  ({ cloudAccounts, auth: { user = {} } = {} }) => ({
    clouds: cloudAccounts.items.filter(c => c.account_type_id === "aws"),
    user
  }),
  dispatch => bindActionCreators({ fetch_clouds }, dispatch)
)(Finance)
